function validate(form) {
  let errors = [];

  if (form.purchase_id == '') {
    errors.push('Please enter your order number');
  }

  if (form.purchase_key == '') {
    errors.push("Please enter the order's shipping zip code or the phone number on the order");
  }

  return errors;
}

export default validate;